import { Component, h, Host, Prop } from "@stencil/core";

/**
 * The `ux-copy` component is used to display text.
 * @slot - The default slot where text content is placed.
 * @internal Currently only for usage in web-apps.
 */
@Component({
    tag: "ux-copy",
    styleUrl: "copy.scss",
    shadow: true
})
export class Copy {
    /**
     * Indicates if the text should be strong.
     * @reflects
     */
    @Prop({ reflect: true }) readonly strong?: boolean;

    /**
     * Indicates if the text should be light.
     * @reflects
     */
    @Prop({ reflect: true }) readonly light?: boolean;

    /**
     * Specifies the variant of the text.
     * @default "default"
     * @reflects
     */
    @Prop({ reflect: true }) readonly variant: "title" | "tiny" | "teaser" | "default" = "default";

    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
